import React, { useContext, useState } from "react";
import { MapContainer, TileLayer, ZoomControl } from "react-leaflet";
import MapFeatures from "./FeatureGroup/MapFeatures";
import MapsLayers from "./MapsLayers/MapsLayers";
import Object from "../LiveTracking/Object/Object";
import { sidebarcontext } from "../../context/Sidebarcontext";
import Positions from "../Positions/Positions";
import ManageZoom from "../Helpers/ManageZoom/ManageZoom";
import Geofences from "../Geofences/Geofences";
import ObjectFocus from "../LiveTracking/ObjectSelected/ObjectDraggable/ObjectFocus";
import { useLocation } from "react-router-dom";
import LeafletGeocoder from "./MapGeoCoder";
import { isRTL } from "../../utils";

export default function Maps() {
	let { isSideOpen } = useContext(sidebarcontext);
	let { pathname } = useLocation();

	// Set the default tile to OpenStreetMap
	const [maptile, setMapTile] = useState(
		"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
	);

	const changeLayers = (layer) => {
		setMapTile(layer);
	};

	const mapClass = isSideOpen ? "map-parent-max" : "map-parent-min";

	return (
		<div className={mapClass}>
			<MapContainer
				id="map-container"
				center={[26.8206, 30.8025]}
				zoomControl={false}
				zoom={6}
				scrollWheelZoom={true}
				minZoom={5}
				maxZoom={18}
				zoomAnimation={true}
				zoomSnap={0.1}
				dragging={true}
				className="map-container"
			>
				<ZoomControl position={isRTL ? "bottomleft" : "bottomright"} />

				<TileLayer
					attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
					url={maptile}
				/>

				<Positions />
				<ManageZoom>
					{pathname === "/geofences" && <MapFeatures />}
					<Geofences />

					<LeafletGeocoder />
					<Object />
				</ManageZoom>
			</MapContainer>
			{pathname === "/livetracking" && <ObjectFocus />}
			<MapsLayers handlelayers={changeLayers} />
		</div>
	);
}
